<div class="card">
  <form [formGroup]="tpaCostForm" (submit)="createHospitalTpacost()">

      <div class="card-body">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-sm-12">
                      <label class="form-label">Hospital Name</label>
                      <h3>{{hospitalName}}</h3>
                  </div>
                  <div class="col-sm-12" *ngIf="myrole=='1' || myrole=='5'">
                      <div class="form-group">
                          <div class="row">
                              <div class="col-sm-3">
                                  <div class="form-group">
                                      <label class="form-label">Treatment *</label>
                                      <mat-select  placeholder="Treatment"  formControlName="treatment_id" (click)="setSearchValue('treatment')">
                                          <input class="mySearchInput"
                                          #treatmentSearch focused="'true'" type="text"
                                          (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                          autocomplete="off"
                                          placeholder="Search"
                                          id="treatmentSearch">
                                          <mat-option [value]="treat.id" *ngFor="let treat of treatments">{{treat.name}}</mat-option>
                                      </mat-select>
                                      <div *ngIf="submitted && t.treatment_id.errors" class="invalid-feedback">
                                          <div *ngIf="t.treatment_id.errors.required">Treatment is required</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="form-label">Tpa *</label>
                                    <mat-select  placeholder="Tpa"  formControlName="tpa_ins_id" (click)="setSearchValue('tpa')" (selectionChange)="setFormValue($event, 'tpa_id')">
                                        <input class="mySearchInput"
                                        #tpaSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'tpa')"
                                        autocomplete="off"
                                        placeholder="Search"
                                        id="tpaSearch">
                                        <mat-option [value]="tpa.id" *ngFor="let tpa of tpaList">{{tpa.tpaName}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && t.tpa_ins_id.errors" class="invalid-feedback">
                                        <div *ngIf="t.tpa_ins_id.errors.required">Tpa is required</div>
                                    </div>
                                </div>
                                </div>
                              <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="form-label">Insurance Company *</label>
                                    <mat-select  placeholder="Insurance Company"  formControlName="ins_comp_id" (click)="setSearchValue('ins_comp')" (selectionChange)="setFormValue($event, 'ins_comp_id')">
                                        <input class="mySearchInput"
                                        #tpaSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'tpa')"
                                        autocomplete="off"
                                        placeholder="Search"
                                        id="tpaSearch">
                                        <mat-option [value]="tpa.id" *ngFor="let tpa of tpaList">{{tpa.insuranceCompanyName}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && t.tpa_id.errors" class="invalid-feedback">
                                        <div *ngIf="t.tpa_id.errors.required">Tpa is required</div>
                                    </div>
                                </div>
                                </div>
                              <div class="col-sm-2">
                                  <div class="form-group">
                                      <label class="form-label">Min Price *</label>
                                      <input type="number" formControlName="price" class="form-control" />
                                      <div *ngIf="submitted && t.price.errors" class="invalid-feedback">
                                          <div *ngIf="t.price.errors.required">Price is required</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-sm-2">
                                <div class="form-group">
                                    <label class="form-label">Max Price *</label>
                                    <input type="number" formControlName="max_price" class="form-control" />
                                    <div *ngIf="submitted && t.max_price.errors" class="invalid-feedback">
                                        <div *ngIf="t.max_price.errors.required">Max Price is required</div>
                                    </div>
                                </div>
                            </div>

                              <div class="col-sm-3">
                                  <button type="submit" [disabled]="loading" class="btn btn-primary treatmentbtm" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                                      <span *ngIf="!tpaCost">Add</span>
                                      <span *ngIf="tpaCost">Update</span>
                                  </button>
                                  <button *ngIf="tpaCost" type="button" class="btn btn-primary treatmentbtm" (click)="resetForm()">
                                      Reset
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="card-footer">
         <h2>Tpa Treatment Cost List</h2>
         <table class="table table-striped hospitalTable">
          <thead>
              <tr>
                  <th>#</th>
                  <th>Treatment</th>
                  <th>Tpa</th>
                  <th>Insurance Company</th>
                  <th>Min Price(Rs.)</th>
                  <th>Max Price(Rs.)</th>
                  <th *ngIf="myrole=='1' || myrole=='5'">Action</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let treatcost of TpaCostList;let index = index;">
                  <td>{{index+1}}</td>
                  <td>{{treatcost.treatmentsName}}</td>
                  <td>{{treatcost.tpaName}}</td>
                  <td>{{treatcost.insuranceCompany}}</td>
                  <td>{{treatcost.cost}}</td>
                  <td>{{treatcost.max_cost}}</td>
                  <td *ngIf="myrole=='1' || myrole=='5'"><i class="fa fa-pen editIcon" (click)="fetchTpaCostData(treatcost.id)"></i></td>
              </tr>
              <tr *ngIf="loading">
                  <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
              </tr>
              <tr *ngIf="!TpaCostList.length">
                  <td colspan="20" ><i class="far fa-frown"></i> Records not found</td>
              </tr>
          </tbody>
          </table>
      </div>
  </form>
</div>
